import { API_ROUTE_ADMIN_PHONE_ACTIVE_NUMBERS_LIST } from '@/resources/api-routes'
import { get } from '@/util/auth'

type ActiveNumbersType = {
  id: number
  name: string
  country_id: number
  phone_number: string
  full_phone_number: string
  department_id?: number
  department_name?: string
  salary_deduction_profile_id?: number
  salary_deduction_profile_name?: string
  is_on_phone_book: 'NO' | 'YES'
  group_id?: number
  group_name?: string
}

const IS_NEW_BACKEND_API = true

export const getActiveNumbersList = async () =>
  get<ActiveNumbersType[]>(API_ROUTE_ADMIN_PHONE_ACTIVE_NUMBERS_LIST, IS_NEW_BACKEND_API)
